import PartnerDirectory from "../components/PartnerDirectory";
import { Sparkles, Sofa, Palette, Ruler } from "lucide-react";

const FEATURES = [
    { icon: Palette, title: "Concept & Mood Boards", desc: "Personalised style discovery — modern, classical, minimalist, Indian traditional or fusion — with 3D visualisations." },
    { icon: Ruler, title: "Space Planning", desc: "Modular kitchens, wardrobes, false ceilings, POP, lighting and furniture layouts to maximise every square foot." },
    { icon: Sofa, title: "Turnkey Fit-Out", desc: "Curated vendor network for carpentry, electricals, plumbing, painting and finishing — one warranty, one point of contact." },
    { icon: Sparkles, title: "Luxury & Budget Tiers", desc: "Transparent per-sqft packages from ₹1,200 (budget) to ₹4,500+ (luxury) — no hidden charges." },
];

export default function InteriorDesigners() {
    return (
        <PartnerDirectory
            role="interior_designer"
            roleLabel="Interior Designers"
            roleLabelSingular="Interior Designer"
            path="/interior-designers"
            heroTag="Interior Design & Fit-Out"
            heroTitle={<>Turn a house into <span className="text-gold-500">the home you dreamt of.</span></>}
            heroSubtitle="Curated interior designers with portfolios spanning 2BHK apartments to 8,000 sqft villas — timely delivery, transparent quotes and 10-year warranty on modular work."
            features={FEATURES}
            jsonLdCategory="ProfessionalService"
        />
    );
}
